import { api } from "./client";

export interface Respuesta {
  id: number;
  nombre: string;
  descripcion: string | null;
  requiereEvidencia: boolean;
  activo: boolean;
}
export interface Autoridad {
  id: number;
  corporacion: string;
  area: string | null;
  responsable: string;
  telefono: string;
  email: string | null;
  notas: string | null;
  activo: boolean;
}
export interface MotivoPausa {
  id: number;
  nombre: string;
  descripcion: string | null;
  requiereComentario: boolean;
  activo: boolean;
}
export interface MotivoDescarte {
  id: number;
  nombre: string;
  descripcion: string | null;
  requiereEvidencia: boolean;
  requiereComentario: boolean;
  activo: boolean;
}
export interface TipoVehiculo {
  id: number;
  nombre: string;
  activo: boolean;
}

export const respuestas = {
  list: () => api.get<Respuesta[]>("/catalogos/respuestas").then((r) => r.data),
  create: (body: { nombre: string; descripcion?: string; requiereEvidencia?: boolean }) =>
    api.post<Respuesta>("/catalogos/respuestas", body).then((r) => r.data),
  update: (id: number, body: Partial<Respuesta>) =>
    api.patch<Respuesta>(`/catalogos/respuestas/${id}`, body).then((r) => r.data),
  remove: (id: number) =>
    api.delete(`/catalogos/respuestas/${id}`).then(() => undefined),
};

export const autoridades = {
  list: () => api.get<Autoridad[]>("/catalogos/autoridades").then((r) => r.data),
  create: (body: Omit<Autoridad, "id" | "activo"> & { activo?: boolean }) =>
    api.post<Autoridad>("/catalogos/autoridades", body).then((r) => r.data),
  update: (id: number, body: Partial<Autoridad>) =>
    api.patch<Autoridad>(`/catalogos/autoridades/${id}`, body).then((r) => r.data),
  remove: (id: number) =>
    api.delete(`/catalogos/autoridades/${id}`).then(() => undefined),
};

export const motivosPausa = {
  list: () => api.get<MotivoPausa[]>("/catalogos/motivos-pausa").then((r) => r.data),
  create: (body: { nombre: string; descripcion?: string; requiereComentario?: boolean }) =>
    api.post<MotivoPausa>("/catalogos/motivos-pausa", body).then((r) => r.data),
};

export const motivosDescarte = {
  list: () => api.get<MotivoDescarte[]>("/catalogos/motivos-descarte").then((r) => r.data),
  create: (body: {
    nombre: string;
    descripcion?: string;
    requiereEvidencia?: boolean;
    requiereComentario?: boolean;
  }) =>
    api.post<MotivoDescarte>("/catalogos/motivos-descarte", body).then((r) => r.data),
};

export const tiposVehiculo = {
  list: () => api.get<TipoVehiculo[]>("/catalogos/tipos-vehiculo").then((r) => r.data),
  create: (body: { nombre: string }) =>
    api.post<TipoVehiculo>("/catalogos/tipos-vehiculo", body).then((r) => r.data),
};
